import { useState } from 'react';
// Material UI
import { FormControl, IconButton, InputAdornment } from '@mui/material';
import { Close, Done, Visibility, VisibilityOff } from '@mui/icons-material';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import ButtonComponent from 'components/design-system/Button/Button';
import { Form } from 'formik';
import Text from 'components/design-system/Text/Text';
import IconComponent from 'components/design-system/icon/Icon';
import { DICTONARY } from 'const/Dictonary';

export const SignupForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
  setFieldTouched,
  validateForm,
  cargando,
  correoInvitado,
  showBotonRegistro = true,
  afterForm = null,
  customDisabled = { email: false, name: false } // Valores por defecto para deshabilitar campos
}) => {
  const [isLoadingEmail, setIsLoadingEmail] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [originalEmailValue, setOriginalEmailValue] = useState('');
  const handleClickShowPassword1 = () => setShowPassword1(show => !show);
  const handleClickShowPassword2 = () => setShowPassword2(show => !show);

  const handleMouseDownPassword = event => {
    event.preventDefault();
  };

  // console.log(values, touched);
  return (
    <Form className="grid grid-cols-12 gap-4" onChange={event => {}}>
      <div className="col-span-12">
        <InputComponent
          autoComplete="new-name" // Desactiva el autocompletado del navegador
          disabled={customDisabled.name}
          textFieldParams={{
            InputProps: {
              readOnly: customDisabled.name,
              disabled: customDisabled.name
            }
          }}
          name={'name'}
          onChange={e => {
            handleChange(e);
          }}
          fullWidth
          value={values.name}
          label={<LabelComponent>Nombre completo</LabelComponent>}
          onBlur={() => {
            setFieldTouched('name');
          }}
          onFocus={() => {
            setFieldValue('activeField', 'name');
          }}
          touched={touched.name ? true : false}
          estado={
            errors.name && touched.name
              ? { tipo: 'error', mensaje: errors.name }
              : null
          }
        />
      </div>
      <div className="col-span-12">
        <InputComponent
          id="email"
          autoComplete="new-email" // Desactiva el autocompletado del navegador
          name={'email'}
          type="text"
          value={values.email ? values.email : ''}
          disabled={customDisabled.email}
          isLoading={isLoadingEmail}
          textFieldParams={{
            InputProps: {
              readOnly: customDisabled.email,
              disabled: customDisabled.email
            }
          }}
          onChange={e => {
            const emailLowercase = e.target.value.trim().toLowerCase();
            setFieldValue('email', emailLowercase);
          }}
          onPaste={e => {
            e.preventDefault();
            const emailLowercase = e.clipboardData
              .getData('Text')
              .trim()
              .toLowerCase();
            setFieldValue('email', emailLowercase);
          }}
          fullWidth
          label={<LabelComponent>Email</LabelComponent>}
          onBlur={e => {
            handleBlur(e);
            const emailLowercase = e.target.value.trim().toLowerCase();
            setFieldValue('email', emailLowercase); // Asegura que siempre almacenes el valor normalizado
            setFieldValue(
              'emailModificado',
              originalEmailValue !== emailLowercase
            );
          }}
          onFocus={e => {
            const emailLowercase = e.target.value.trim().toLowerCase();
            setOriginalEmailValue(emailLowercase); // Asegurar minúsculas en el valor inicial
          }}
          touched={touched.email}
          estado={
            errors.email && touched.email
              ? { tipo: 'error', mensaje: errors.email }
              : null
          }
        />
      </div>
      <div className="col-span-12">
        <FormControl variant="outlined" fullWidth>
          <InputComponent
            name={'password1'}
            autoComplete="new-password" // Desactiva el autocompletado del navegador
            type={showPassword1 ? 'text' : 'password'}
            onChange={e => {
              handleChange(e);
            }}
            onFocus={() => {
              setFieldValue('activeField', 'password1');
            }}
            value={values.password1}
            fullWidth
            label={<LabelComponent>Contraseña</LabelComponent>}
            outerInputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword1}
                    onMouseDown={handleMouseDownPassword}
                    size="small"
                  >
                    {showPassword1 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
            onBlur={() => {
              setFieldTouched('password1');
            }}
            touched={touched.password1 ? true : false}
            estado={
              errors.password1 && touched.password1
                ? { tipo: 'error', mensaje: '' }
                : null
            }
          />
        </FormControl>
        {values.password1.length > 0 && (
          <>
            <ul className="mt-4 mb-4">
              {values.password1.length < 8 && (
                <Text className="text-error-dark">{errors.password1}</Text>
              )}
              {values.password1.length > 7 && (
                <>
                  <li className="flex items-center mb-1">
                    <IconComponent className="mr-2">
                      {errors.password1 !== 'numero' ? (
                        <Done className="text-base" />
                      ) : (
                        <Close className="text-base text-error-dark" />
                      )}
                    </IconComponent>

                    <Text>Tiene al menos un número</Text>
                  </li>

                  {errors.password1 !== 'numero' && (
                    <li className="flex items-center mb-1">
                      <IconComponent className="mr-2">
                        {errors.password1 !== 'mayuscula' ? (
                          <Done className="text-base" />
                        ) : (
                          <Close className="text-base text-error-dark" />
                        )}
                      </IconComponent>
                      <Text>Tiene al menos una mayúscula</Text>
                    </li>
                  )}
                  {errors.password1 !== 'numero' &&
                    errors.password1 !== 'mayuscula' && (
                      <li className="flex items-center mb-1">
                        {
                          <IconComponent className="mr-2">
                            {errors.password1 !== 'minuscula' ? (
                              <Done className="text-base" />
                            ) : (
                              <Close className="text-base text-error-dark" />
                            )}
                          </IconComponent>
                        }
                        <Text>Tiene al menos una minúscula</Text>
                      </li>
                    )}
                  {errors.password1 !== 'numero' &&
                    errors.password1 !== 'mayuscula' &&
                    errors.password1 !== 'minuscula' && (
                      <li className="flex items-center mb-1 text-error-dark">
                        {
                          <IconComponent className="mr-2">
                            {errors.password1 !== 'caracter' ? (
                              <Done className="text-base" />
                            ) : (
                              <Close className="text-base text-error-dark" />
                            )}
                          </IconComponent>
                        }
                        <Text
                          className={
                            errors.password1 === 'caracter' &&
                            'text-error-dark font-semibold'
                          }
                        >
                          Tiene un carácter especial ej: ej: #@,"
                        </Text>
                      </li>
                    )}
                </>
              )}
            </ul>
          </>
        )}
      </div>
      <div className="col-span-12 mb-4">
        <FormControl variant="outlined" fullWidth>
          <InputComponent
            name={'password2'}
            autoComplete="new-password2" // Desactiva el autocompletado
            type={showPassword2 ? 'text' : 'password'}
            onFocus={() => {
              setFieldValue('activeField', 'password2');
            }}
            onChange={e => {
              handleChange(e);
            }}
            value={values.password2}
            fullWidth
            label={<LabelComponent>Repetir contraseña</LabelComponent>}
            outerInputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onClick={handleClickShowPassword2}
                    onMouseDown={handleMouseDownPassword}
                  >
                    {showPassword2 ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
            onBlur={() => {
              setFieldTouched('password2');
            }}
            touched={touched.password2 ? true : false}
            estado={
              errors.password2 && touched.password2
                ? { tipo: 'error', mensaje: errors.password2 }
                : null
            }
          />
        </FormControl>
      </div>

      {afterForm}

      {showBotonRegistro && (
        <div className="col-span-12 text-center">
          <ButtonComponent
            isLoading={cargando}
            disabled={
              Object.keys(errors).length === 0 && !cargando ? false : true
            }
            buttonType="submit"
            onClick={() => {
              validateForm()
                .then(result => {})
                .catch(err => {});
            }}
            className="min-w-[180px] justify-center"
          >
            {cargando ? 'Creando cuenta' : 'Registrar cuenta'}
          </ButtonComponent>
        </div>
      )}
    </Form>
  );
};
